var outdatedBrowserRework = require("outdated-browser-rework")

// test
// outdatedBrowserRework({
//   fullscreen: false,
//   browserSupport: {
//     'Chrome': false,
//     'Edge': false,
//     'Safari': false,
//     'Mobile Safari': false,
//     'Firefox': false,
//     'Opera': false,
//     'IE': false
//   }
// })

// defaults
outdatedBrowserRework({
  browserSupport: {
    'Chrome': 57, // Includes Chrome for mobile devices
    'Edge': 39,
    'Safari': 10,
    'Mobile Safari': 10,
    'Firefox': 50,
    'Opera': 50,
    'Vivaldi': 1,
    // You could specify minor version too for those browsers that need it.
    'Yandex': { major: 17, minor: 10 },
    // You could specify a version here if you still support IE in 2017.
    // You could also instead seriously consider what you're doing with your time and budget
    'IE': false
  },
  requireChromeOnAndroid: false,
  isUnknownBrowserOK: false, 
  messages: {
    en: {
      outOfDate: "Your browser is out of date.",
      update: {
        web: "Update your browser to view this website correctly. ",
        googlePlay: "Please install Chrome from Google Play",
        appStore: "Please update iOS from the Settings App"
      },
      url: "http://outdatedbrowser.com/",
      callToAction: "Update my browser now",
      close: "Close"
    }
  }
})


// WEBPACK FOOTER //
// /resources/js/plugins/outdated-browser.js